export const MS_PER_SEC = 1000;

/** Rounds a number of milliseconds to the nearest whole second rounding down. */
export default function fuzzMilliseconds(num: number) {
  return Math.floor(num / MS_PER_SEC) * MS_PER_SEC;
}
